import React from 'react'
import MainLayout from '../../components/TheMainLayout/MainLayout'
import LoginForm from '../../components/Forms/LoginForm'

const SignIn: React.FC = () => {
  return (
    <MainLayout>
      <div className="page-row">
        <h1 className="h-text-center">Přihlášení</h1>
        <p className="h-text-center">
          Již jste zakoupili některý z našich kurzu? Jednoduše se přihlašte.
        </p>
        <LoginForm />
      </div>
    </MainLayout>
  )
}

export default SignIn
